module.exports = "/packs/course-small-contents-marketing-8bec5a8c65edc4b24073c5438e87fe0f.png";